import { forwardRef, useCallback } from 'react';

import { __, castArray, filter, identity, size, some } from 'lodash/fp';

import { OdooCompany, Pointing } from '../../types/models';
import PointingDetailMobile from '../mobile/PointingDetail';
import withPlatformComponent from '../withPlatformComponent';

export enum ViewMode {
    Manual,
    Confirm,
    Adherent,
}

export type PointingDetailProps = {
    initialPointing: Pointing;
    isDisabled?: boolean;
    viewMode: ViewMode;
    fieldsToHighlight?: string[];
    highlightColor?: string;
    onChange?: (pointing: Pointing) => void;
};

export type PointingDetailHandle = {
    getPointing: () => Pointing;
};

export const VisibilityField: React.FC<{
    company?: OdooCompany;
    companyAttributes: (keyof OdooCompany)[];
    children?: React.ReactNode;
}> = ({ company, companyAttributes, children }) => {
    if (!children || !company) {
        return null;
    }

    let hasValue = some((attr) => size(filter(identity, castArray(company[attr]))) > 0, companyAttributes);

    if (!hasValue) {
        return null;
    }

    return <>{children}</>;
};

// Utiliser forwardRef pour permettre la référence à PointingDetail
const PointingDetail = forwardRef<PointingDetailHandle, PointingDetailProps>((props, ref) => {
    const PlatformSpecificPointingDetail = useCallback(
        withPlatformComponent({
            web: PointingDetailMobile,
            mobile: PointingDetailMobile,
        }),
        [],
    );

    return <PlatformSpecificPointingDetail {...props} ref={ref} />;
});

export default PointingDetail;
